export function parseTier(planId: string): string {
  const parts = planId.toLowerCase().split('-')
  return parts[1] ?? 'base'
}
